import React, { useState, useEffect } from "react";
import validator from "validator";
import { Select } from "antd";

export default function TtEmail(props) {
  const { component, currentConfig, handleChange, toIntIf, values } = props;
  const [emailError, setEmailError] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [denomination, setDenomination] = useState("");
  const [vat, setVat] = useState("");
  const [cf, setCf] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [telephone, setTelephone] = useState("");
  const [installation, setInstallation] = useState("");
  const [readonly, setReadonly] = useState(false);
  const [userid, setUserId] = useState(false);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("");
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [province, setProvince] = useState("");
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const [installationVisible, setInstallationVisible] = useState(false);

  useEffect(() => {
    const getNazioni = async () => {
      const resp = await fetch(
        "https://www.kit.solutions/api/zucchetti/nazioni/"
      );
      const nazioni = await resp.json();
      setCountries(nazioni);
    };
    getNazioni().catch(console.error);
  }, []);

  useEffect(() => {
    if (country == "Italia") {
      const getRegions = async () => {
        const resp = await fetch(
          "https://www.kit.solutions/api/zucchetti/regioni/"
        );
        const regioni = await resp.json();
        setRegions(regioni);
      };
      getRegions().catch(console.error);
    }
  }, [country]);

  useEffect(() => {
    if (region != "") {
      const getProvince = async () => {
        const resp = await fetch(
          "https://www.kit.solutions/api/zucchetti/province/" +
            encodeURIComponent(region).replace("'", "____") +
            "/"
        );
        const prov = await resp.json();
        setProvinces(prov);
      };
      getProvince().catch(console.error);
    }
  }, [region]);

  useEffect(() => {
    if (province != "") {
      const getCities = async () => {
        const resp = await fetch(
          "https://www.kit.solutions/api/zucchetti/comuni/" +
            encodeURIComponent(province).replace("'", "____") +
            "/"
        );
        const prov = await resp.json();
        setCities(prov);
      };
      getCities().catch(console.error);
    }
  }, [province]);

  // Email Validation
  const validateEmail = (email) => {
    if (validator.isEmail(email)) {
      setEmailError(false);
      handleChange({
        [component.name]: email,
      });

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        user_email: email,
      });
      console.log("dataLayer value pushed: user_email");

      window.dataLayer.push({
        event: "contact_form_configuratore",
      });
      console.log("dataLayer event pushed: contact_form_configuratore");

      updateAnag("POST", {
        email: emailValue,
        lingua: document.documentElement.lang,
      });
    } else {
      setEmailError(true);
    }
  };

  async function updateAnag(method, anagPayload) {
    try {
      const requestOptions = {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(anagPayload),
      };
      const res = await fetch(
        "https://www.kit.solutions/api/account/",
        requestOptions
      );

      const resp = await res.json();

      setUserId(resp?.data?.id);
      setDenomination(resp?.data?.ragione_sociale || "");
      setCf(resp?.data?.codice_fiscale || "");
      setVat(resp?.data?.partita_iva || "");
      setName(resp?.data?.nome || "");
      setSurname(resp?.data?.cognome || "");
      setTelephone(resp?.data?.telefono || "");
      //setInstallation(resp?.data?.luogo_installazione || "");
      handleChange({ userid: resp?.data?.id });
      if (resp?.data?.nome || resp?.data?.cognome || resp?.data?.telefono) {
        setReadonly(true);
        setInstallationVisible(true);
      }
    } catch (e) {}
  }

  return (
    <>
      {" "}
      <div>
        <input
          type="email"
          onChange={(e) => {
            setEmailValue(e.target.value);
          }}
          className="tt-email"
          value={emailValue}
          readOnly={userid ? true : false}
        />
        {!userid && (
          <button
            className="tt-btn-checkemail"
            onClick={() => validateEmail(emailValue)}
          >
            Verifica email
          </button>
        )}
        {emailError && <small style={{ color: "red" }}>Email non valida</small>}
      </div>
      {userid && (
        <>
          <div>
            <label>Ragione Sociale</label>
            <input
              type="text"
              onChange={(e) => {
                setDenomination(e.target.value);
              }}
              className="tt-email"
              value={denomination}
              readOnly={readonly}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "100%", marginRight: 15 }}>
              <label>*Nome</label>
              <input
                type="text"
                onChange={(e) => {
                  setName(e.target.value);
                }}
                className="tt-name"
                value={name}
                readOnly={readonly}
              />
            </div>
            <div style={{ width: "100%" }}>
              <label>*Cognome</label>
              <input
                type="text"
                onChange={(e) => {
                  setSurname(e.target.value);
                }}
                className="tt-name"
                value={surname}
                readOnly={readonly}
              />
            </div>
          </div>
          <div>
            <label>*Telefono</label>
            <input
              type="text"
              onChange={(e) => {
                setTelephone(e.target.value);
              }}
              className="tt-name"
              value={telephone}
              readOnly={readonly}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "100%" }}>
              <label>Codice fiscale</label>
              <input
                type="text"
                onChange={(e) => {
                  setCf(e.target.value);
                }}
                className="tt-cf"
                value={cf}
                readOnly={readonly}
              />
            </div>
            <div style={{ width: "100%", marginLeft: 15 }}>
              <label>Partita iva</label>
              <input
                type="text"
                onChange={(e) => {
                  setVat(e.target.value);
                }}
                className="tt-vat"
                value={vat}
                readOnly={readonly}
              />
            </div>
          </div>
          <br />
          {!readonly && (
            <button
              className="tt-btn-checkemail"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (telephone !== "" || name !== "" || surname !== "") {
                  updateAnag("PUT", {
                    id: userid,
                    ragione_sociale: denomination,
                    codice_fiscale: cf,
                    partita_iva: vat,
                    email: emailValue,
                    lingua: document.documentElement.lang,
                    nome: name,
                    cognome: surname,
                    telefono: telephone,
                  });
                } else {
                  alert("i campi contrassegnati con * richiesti");
                }
              }}
            >
              SALVA I TUOI DATI PER CONTINUARE
            </button>
          )}
          <hr />
          {(installationVisible || readonly) && (
            <div>
              <h3>
                * Luogo Installazione
                {country && (
                  <div className="tag">
                    {country != "" && (
                      <div>
                        {country}{" "}
                        <span
                          onClick={() => {
                            setCountry(false);
                            setRegion(false);
                            setProvince(false);
                            setCity(false);
                          }}
                        >
                          x
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {region && (
                  <div className="tag">
                    {region != "" && (
                      <div>
                        {region}{" "}
                        <span
                          onClick={() => {
                            setRegion(false);
                            setProvince(false);
                            setCity(false);
                          }}
                        >
                          x
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {province && (
                  <div className="tag">
                    {province != "" && (
                      <div>
                        {province}{" "}
                        <span
                          onClick={() => {
                            setProvince(false);
                            setCity(false);
                          }}
                        >
                          x
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </h3>
              {country != "Italia" && (
                <div>
                  <label>Seleziona Nazione</label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder={`Seleziona ...`}
                    size="large"
                    options={[
                      { label: "seleziona ...", value: false },
                      { label: "Italia", value: "Italia" },
                      ...countries.map((v, k) => {
                        return {
                          label: v.nome,
                          value: v.nome,
                        };
                      }),
                    ]}
                    //value={values[component.name] ? values[component.name] : null}
                    name="country"
                    onChange={(value, el) => {
                      handleChange({ country: value });
                      if (value != "Italia") {
                        handleChange({ installation: el.label });
                      }
                      setCountry(value);
                    }}
                  />
                </div>
              )}
              {country == "Italia" && region == "" && (
                <div>
                  <label>Seleziona Regione</label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder={`Seleziona ...`}
                    size="large"
                    options={[
                      { label: "seleziona ...", value: false },

                      ...regions.map((v, k) => {
                        return {
                          label: v.regione,
                          value: v.regione,
                        };
                      }),
                    ]}
                    //value={values[component.name] ? values[component.name] : null}
                    name="region"
                    onChange={(value) => {
                      handleChange({ region: value });
                      setRegion(value);
                    }}
                  />
                </div>
              )}
              {region != "" && province == "" && (
                <>
                  <label>Provincia</label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder={`Seleziona ...`}
                    size="large"
                    options={[
                      { label: "seleziona ...", value: false },

                      ...provinces.map((v, k) => {
                        return {
                          label: v.provincia,
                          value: v.provincia,
                        };
                      }),
                    ]}
                    //value={values[component.name] ? values[component.name] : null}
                    name="region"
                    onChange={(value) => {
                      handleChange({ province: value });
                      setProvince(value);
                    }}
                  />
                </>
              )}
              {province != "" && (
                <>
                  <label>Città</label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder={`Seleziona ...`}
                    size="large"
                    options={[
                      { label: "seleziona ...", value: false },

                      ...cities.map((v, k) => {
                        return {
                          label: v.Citta,
                          value: v.CodiceIstat,
                        };
                      }),
                    ]}
                    //value={values[component.name] ? values[component.name] : null}
                    name="city"
                    onChange={(value, el) => {
                      handleChange({ cityCode: value, installation: el.label });
                      setCity(value);
                    }}
                  />
                </>
              )}

              {/*<input
              type="text"
              onChange={(e) => {
                setInstallation(e.target.value);
              }}
              onBlur={() => {
                handleChange({
                  installation: installation,
                });
              }}
              className="tt-vat"
              value={installation}
            />*/}
            </div>
          )}
        </>
      )}
    </>
  );
}
